module.exports = __webpack_public_path__ + "static/media/About-Table-ExternalLink.fd978112.svg";